module.exports = __webpack_public_path__ + "static/media/wicketRoundPykes.d5f30d4b.jpg";